import { render, staticRenderFns } from "./InvoiceHandleTab.vue?vue&type=template&id=08438eb4&scoped=true"
import script from "./InvoiceHandleTab.vue?vue&type=script&lang=js"
export * from "./InvoiceHandleTab.vue?vue&type=script&lang=js"
import style0 from "./InvoiceHandleTab.vue?vue&type=style&index=0&id=08438eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08438eb4",
  null
  
)

export default component.exports